import { computed, inject, Injectable } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { Store } from '@ngxs/store'
import { PreferenceState } from '../../store/preference/preference.state'
import { AuthState } from '../../store/auth/auth.state'
import { NetworkService } from './network.service'

@Injectable({ providedIn: 'root' })
export class OfflineActivityService {
  private readonly store = inject(Store)
  private readonly networkService = inject(NetworkService)

  private readonly isMobile = this.store.selectSignal(PreferenceState.isMobile)
  private readonly isAuthenticated = this.store.selectSignal(
    AuthState.isAuthenticated
  )
  private readonly isOnline = toSignal(this.networkService.isOnlineObs$)
  private readonly isInitialPageLoadFromOffline = this.store.selectSignal(
    AuthState.isInitialPageLoadFromOffline
  )

  public readonly isPopupAboutWaitingWiFiToBeResumedShown = computed(() => {
    const isMobile = this.isMobile()
    const isAuthenticated = this.isAuthenticated()
    const isOffline = !this.isOnline()
    const isInitialPageLoadFromOffline = this.isInitialPageLoadFromOffline()
    return (
      isMobile && isAuthenticated && isOffline && isInitialPageLoadFromOffline
    )
  })
}
